import { render, staticRenderFns } from "./UiHint.vue?vue&type=template&id=67bbe986&"
import script from "./UiHint.vue?vue&type=script&lang=js&"
export * from "./UiHint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports